<h2 mat-dialog-title class="dialog-title">{{ data.titulo }}</h2>

<mat-dialog-content>
  <p class="dialog-message">{{ data.intro }}</p>

  <ul class="ayuda-pasos">
    <li *ngFor="let paso of data.pasos">{{ paso }}</li>
  </ul>

  <div class="ayuda-pie">
    <p class="ayuda-contacto">
      <mat-icon>mail_outline</mat-icon>
      <span>¿Te quedan dudas? Escríbenos a
        <a [href]="'mailto:' + marca.emailContacto">{{ marca.emailContacto }}</a>
      </span>
    </p>

    <div class="ayuda-meta">
      <button type="button" class="ayuda-enlace" (click)="openLegal('privacidad')">Política de Privacidad</button>
      <span class="ayuda-sep">·</span>
      <button type="button" class="ayuda-enlace" (click)="openLegal('condiciones')">Términos de Uso</button>
      <span class="ayuda-spacer"></span>
      <span class="ayuda-version">v{{ appVersion }}</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button mat-dialog-close>Entendido</button>
</mat-dialog-actions>
